module.exports = __webpack_public_path__ + "img/touzizhe-banner.54cdab96.jpg";